// extracted by css-extract-rspack-plugin
export default {"SavedEntityListRoot":"Fqg01","SavedEntityListItem":"qqXQK","SavedEntityListItemIcon":"S4wXb","LoadingWrapper":"rtFLJ"};